import React, { memo } from 'react';
import bem from 'utils/bem';
import UserAgreementCheckboxField from 'forms/fields/UserAgreementCheckboxField';
import CancelRulesCheckboxField from 'forms/fields/CancelRulesCheckboxField';
import MoscowTimeCheckboxField from 'forms/fields/MoscowTimeCheckboxField';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import { formatPrice } from 'utils/format';

const { el } = bem('order-form', 'form');
const Summary = ({ price, submitting, kzNotEnoughBalance }) => {
    return (
        <div className={ el('summary-block') }>
            <div className={ el('summary-ticks') }>
                <div className={ el('user-agreement-check') }>
                    <UserAgreementCheckboxField name={ 'acceptConditions' }/>
                </div>
                <div className={ el('cancel-rules-check') }>
                    <CancelRulesCheckboxField name={ 'acceptCancelRules' }/>
                </div>
                <div className={ el('moscow-time-check') }>
                    <MoscowTimeCheckboxField name={ 'acceptMoscowTime' }/>
                </div>
            </div>
            <div className={ el('summary-bottom') }>
                <div className={ el('summary-left') }>
                    <div className={ el('summary-price') }>
                        <div className={ el('summary-price-label') }>
                            <Text>Итоговая стоимость</Text>
                        </div>
                        <div className={ el('summary-price-value') }>
                            <Text serif>{ formatPrice(price) }</Text>
                        </div>
                    </div>
                </div>
                <div className={ el('summary-right') }>
                    <div className={ el('submit-button') }>
                        <IconButton name={ 'arrow-right' } mod={ 'gold' }
                                    disabled={ submitting || kzNotEnoughBalance } type={ 'submit' }>
                            <Text serif>Оплатить и записаться</Text>
                        </IconButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(Summary);
